<template>
    <div class="list_wrap">
        <div class="result-list">
            <el-table ref="multipleTable2" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" @current-change="currentChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column property="" label="用户">
                    <template slot-scope="scope">
                        <div class="anchorHead">
                            <img class="anchorLogo" :src="scope.row.coverurl" alt="">
                            <span>{{scope.row.eventname}}</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <page :total="total" @getList="_getList" ref="page"></page>
        </div>
    </div>
</template>

<script>
    import {getRelEventListByLive} from 'api/vliveV2Api'
    import Page from 'base/page/page'
    import {mapGetters, mapActions} from 'vuex'
    export default {
        name: "list2",
        data(){
            return{
                param:{
                    eventname:'', //活动名称
                    jkteventtype:'4', //活动类型 5全民分销 4助力砍价 10品牌商开团活动 ,
                },
                tableData:[],
                total:0,
                multipleSelection:[]
            }
        },
        mounted(){
          this._getList()
            this.$refs.multipleTable2.clearSelection();
        },
        methods:{
            //获取活动列表
            _getList(){
                this.setLoading(true);
                getRelEventListByLive({
                    data: Object.assign({}, this.param,this.page),
                    success: data => {
                        this.setLoading(false);
                        this.tableData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            handleSelectionChange(val) {
                if (val.length > 1) {
                    this.$refs.multipleTable2.clearSelection();
                    this.$refs.multipleTable2.toggleRowSelection(val.pop())
                }
                this.multipleSelection = val.pop();
                this.$emit('getTable',this.multipleSelection)
                // console.log(val);
                // this.multipleSelection = val;
                // this.$emit('getTable',this.multipleSelection)
            },
            //搜索
            handleQuery(name){
                this.param.eventname=name;
                this.$refs.page.handleSizeChange(1)
            },
            //点击整行选中
            currentChange(currentRow){
                this.$refs.multipleTable2.toggleRowSelection(currentRow)
            },
            ...mapActions([
                'setLoading',
            ])
        },
        computed: {
            ...mapGetters([
                'page',
            ])
        },
        components: {
            Page
        }
    }
</script>

<style lang="scss">
    .list_wrap{
        padding: 0 0!important;
        .el-dialog .el-button{
            margin-bottom: 10px;
        }
        .result-list{
            width: 100%;
            .el-table__body-wrapper{
                max-height: 300px;
                overflow-y: scroll;
            }
            .el-table thead{
                display: none;
            }
            .el-table__row{
                height: 70px;
                background: #fff!important;
            }
            .anchorHead{
                display: flex;
                align-items: center;
            }
        }
    }
</style>
